import classNames from 'classnames';
import { PropTypes } from 'prop-types';
import React from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import {
  checkCurrencyFormatting,
  fieldRequired,
  requiredInput,
} from '../../../core/formValidation';

export const PurchaseOrderItemFields = ({ name = 'items' }) => {
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({ control, name });

  return (
    <div className="inline-add-item-button">
      {fields.map((field, index) => (
        <div key={field.id} className="field-row">
          <div className="field-row-heading">
            <label>Item {index + 1}</label>
            <button
              type="button"
              className={classNames('close', 'no-float', 'multi-form-delete')}
              onClick={() => {
                remove(index);
              }}
            >
              <i className="icon icon-squared-cross" />
            </button>
          </div>
          <div>
            <div className="form-group form-small-row purchase-order-row">
              <span>
                <Controller
                  name={`${name}.${index}.name`}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: inputField }) =>
                    requiredInput({
                      input: inputField,
                      id: 'name',
                      type: 'text',
                      className: 'form-control row-padding',
                      placeholder: 'Item name',
                    })
                  }
                />
              </span>
              <span>
                <Controller
                  name={`${name}.${index}.quantity`}
                  control={control}
                  rules={{ required: true }}
                  render={({ field: inputField }) =>
                    requiredInput({
                      input: inputField,
                      id: 'quantity',
                      type: 'number',
                      className: 'form-control row-padding',
                      placeholder: 'Qty',
                      min: '0',
                      style: { width: '60px' },
                    })
                  }
                />
              </span>
              <span>
                <Controller
                  name={`${name}.${index}.price`}
                  control={control}
                  rules={{
                    validate: (v) =>
                      !v || checkCurrencyFormatting({ input: { value: v } }) === undefined,
                  }}
                  render={({ field: inputField }) =>
                    requiredInput({
                      input: inputField,
                      id: 'price',
                      type: 'text',
                      className: 'form-control row-padding',
                      commas: 'true',
                      decimal: '2',
                      placeholder: 'Amount ($0.00)',
                      style: { width: '140px' },
                    })
                  }
                />
              </span>
            </div>
          </div>
        </div>
      ))}
      <button
        type="button"
        className={classNames('button', 'full-width')}
        onClick={() => {
          append({});
        }}
      >
        Add Item
      </button>
    </div>
  );
};

PurchaseOrderItemFields.propTypes = {
  name: PropTypes.string,
};

export default PurchaseOrderItemFields;
